export default class DogModel {
  constructor(
    id: number,
    mainimage: string,
    name: string,
    SOMETHINGUNKNOWN: string,
    regnr: string,
    birthdate: string,
    color: string,
    dentition: string,
    hd: string,
    ad: string,
    eyechecked: string,
    optigen: string,
    cnm: string,
    eic: string,
    dwarfism: string,
    hdindex: string,
    pedigree: string,
    fieldtrails: string[],
    exhibitions: string[],
    description: string,
    images: string[]
  ) {
    this.id = id;
    this.mainimage = mainimage;
    this.name = name;
    this.SOMETHINGUNKNOWN = SOMETHINGUNKNOWN; // f.eks. (Gamefinder Amigo - Foxon Vivivi)
    this.regnr = regnr;
    this.birthdate = birthdate;
    this.color = color;
    this.dentition = dentition; // Tandsæt
    this.hd = hd;
    this.ad = ad;
    this.eyechecked = eyechecked; // Øjenlyst
    this.optigen = optigen;
    this.cnm = cnm;
    this.eic = eic;
    this.dwarfism = dwarfism; // Dværgvækst
    this.hdindex = hdindex;
    this.pedigree = pedigree; // Stamtavle
    this.fieldtrails = fieldtrails;
    this.exhibitions = exhibitions;
    this.description = description;
    this.images = images;
  }

  id: number;
  mainimage: string;
  name: string;
  SOMETHINGUNKNOWN: string;
  regnr: string;
  birthdate: string;
  color: string;
  dentition: string;
  hd: string;
  ad: string;
  eyechecked: string;
  optigen: string;
  cnm: string;
  eic: string;
  dwarfism: string;
  hdindex: string;
  pedigree: string;
  fieldtrails: string[];
  exhibitions: string[];
  description: string;
  images: string[];
}

// - Billede
// - Navn
// - Noget ukendt i parantes
// - DKK reg.nr.
// - Født (dato)
// - Farve
// - Tandsæt
// - HD
// - AD
// - Øjenlyst
// - Optigen
// - CNM
// - EIC
// - Dværgvækst
// - Stamtavle (evt bare et link)
// - Markprøver/fieldtrails (array)
// - Udstillinger (array)
// - Beskrivelse
